import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import blogData from './blogData';
import NewsletterSignup from './NewsletterSignup';
import '../css/BlogCard.css';

const BlogPost = () => {
    const { id } = useParams();
    const post = blogData.find(post => post.id === id);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (!post) {
        return <div>Post not found</div>;
    }

    return (
        <article className="blog-post">
            <Link to="/blog" className="blog-post-back">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.8333 10H4.16666" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9.99999 15.8334L4.16666 10L9.99999 4.16669" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Back to Articles
            </Link>

            <header className="blog-post-header">
                <div className="blog-post-tags">
                    {post.tags.map((tag, index) => (
                        <span key={index} className="blog-card-tag">
                            {tag}
                        </span>
                    ))}
                </div>
                <h1 className="blog-post-title">{post.title}</h1>
                <div className="blog-post-meta">
                    <div className="blog-post-date">{post.date}</div>
                    <div className="blog-post-read-time">
                        {Math.ceil((post.content?.split(/\s+/)?.length || 0) / 200)} min read
                    </div>
                </div>
            </header>

            <div 
                className="blog-post-content"
                dangerouslySetInnerHTML={{ __html: post.content }}
            />

            <NewsletterSignup />
        </article>
    );
};

export default BlogPost; 